export enum EventNames {
    loggedIn = "loggedIn",
    languageChanged = "languageChanged",
    reloadAbsences = "reloadAbsences",
    reloadAttentiondays = "reloadAttentiondays",
    editAbsence = "editAbsence",
    validationError = "validationError",
    loggedOut = "loggedOut"
}
